export default __webpack_public_path__ + "static/media/covid-image.e87d3273.jpg";